import Toastr from '../../../itrust_common/components/Toastr';

const emptyMeta = { pagination: {} };

const DEFAULT_STATE = {
  roll_forward: [],
  roll_forward_meta: emptyMeta,
  roll_forward_saving: false,
  on_hand: [],
  on_hand_meta: emptyMeta,
  on_hand_saving: false,
  at_lab: [],
  at_lab_meta: emptyMeta,
  at_lab_saving: false,
  sales_report: [],
  sales_report_meta: emptyMeta,
  sales_report_saving: false,
  tax_report: [],
  tax_report_meta: emptyMeta,
  tax_report_saving: false,
};

const getRows = (response) => {
  if (Array.isArray(response?.data)) return response.data
  if (Array.isArray(response?.eyeglass_lens_frames)) return response.eyeglass_lens_frames
  if (Array.isArray(response?.records)) return response.records
  if (Array.isArray(response)) return response
  return []
}

export default function inventoryReportReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'INVENTORY_ROLL_FORWARD_LOAD_PENDING':
      return { ...state, roll_forward_saving: true };

    case 'INVENTORY_ON_HAND_LOAD_PENDING':
      return { ...state, on_hand_saving: true };

    case 'INVENTORY_AT_LAB_LOAD_PENDING':
      return { ...state, at_lab_saving: true };

    case 'SALES_REPORT_LOAD_PENDING':
      return { ...state, sales_report_saving: true };

    case 'TAX_REPORT_LOAD_PENDING':
      return { ...state, tax_report_saving: true };

    case 'INVENTORY_ROLL_FORWARD_LOAD_REJECTED':
    case 'INVENTORY_ON_HAND_LOAD_REJECTED':
    case 'INVENTORY_AT_LAB_LOAD_REJECTED':
    case 'SALES_REPORT_LOAD_REJECTED':
    case 'TAX_REPORT_LOAD_REJECTED':
      Toastr.handleShow(response?.data?.success, response?.data?.error, response?.data?.status_code);
      return {
        ...state,
        roll_forward_saving: false,
        on_hand_saving: false,
        at_lab_saving: false,
        sales_report_saving: false,
        tax_report_saving: false,
      };

    case 'INVENTORY_ROLL_FORWARD_LOAD_FULFILLED':
      return {
        ...state,
        roll_forward: getRows(response),
        roll_forward_meta: response?.meta || emptyMeta,
        roll_forward_saving: false,
      };

    case 'INVENTORY_ON_HAND_LOAD_FULFILLED':
      return {
        ...state,
        on_hand: getRows(response),
        on_hand_meta: response?.meta || emptyMeta,
        on_hand_saving: false,
      };

    case 'INVENTORY_AT_LAB_LOAD_FULFILLED':
      return {
        ...state,
        at_lab: getRows(response),
        at_lab_meta: response?.meta || emptyMeta,
        at_lab_saving: false,
      };

    case 'SALES_REPORT_LOAD_FULFILLED':
      return {
        ...state,
        sales_report: getRows(response),
        sales_report_meta: response?.meta || emptyMeta,
        sales_report_saving: false,
      };

    case 'TAX_REPORT_LOAD_FULFILLED':
      return {
        ...state,
        tax_report: getRows(response),
        tax_report_meta: response?.meta || emptyMeta,
        tax_report_saving: false,
      };

    case 'RESET_INVENTORY_REPORT':
      return DEFAULT_STATE;

    default:
      return state;
  }
}
